/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import API from 'js/lib/api';
import redirect from 'js/lib/coursera.redirect';

import Alert from 'bundles/authentication-common/components/Alert';
import type { AUTHENTICATION_MODAL_MODES_KEY } from 'bundles/authentication-common/constants';

import _t from 'i18n!nls/authentication';

type Props = {
  id: string;
  redirect?: string;
  navigate: (path: AUTHENTICATION_MODAL_MODES_KEY, options?: $TSFixMe) => void;
};

type State = {
  hasError?: boolean;
};

const styles = {
  container: css`
    display: grid;
    grid-gap: var(--cds-spacing-400);
    grid-template-columns: 1fr;
    margin: 0 auto;
    padding: var(--cds-spacing-400) var(--cds-spacing-200);
    max-width: 396px;
  `,
};

class Redirection extends React.Component<Props, State> {
  state: State = {};

  async componentDidMount() {
    const { id, redirect: redirectTo } = this.props;

    const searchParams = new URLSearchParams();
    searchParams.append('action', 'initiateLoginFlow');
    searchParams.append('id', id);
    searchParams.append('returnTo', redirectTo || redirect.getPathname() + redirect.getQueryParams());

    // Redirect to the SSO login
    try {
      window.location = await API('/api/thirdPartyOrganizations.v1').post(`?${searchParams.toString()}`);
    } catch {
      this.setState({ hasError: true });
    }
  }

  render() {
    const { hasError } = this.state;

    return (
      <section className="rc-Redirection" css={styles.container}>
        <header>
          <h1>{_t('Redirecting')}</h1>
        </header>
        {hasError && <Alert>{_t('An unexpected error occurred. Please try again later.')}</Alert>}
      </section>
    );
  }
}

export default Redirection;
